import { validateArguments } from '../../SignatureValidation';
export var TotalFn;
(function (TotalFn) {
    TotalFn.Name = `TOTAL`;
    TotalFn.Stage = "ANALYTIC";
    TotalFn.Signature = `TOTAL(<expression>)`;
    function make(callName, args, type, role) {
        return {
            name: TotalFn.Name,
            stage: TotalFn.Stage,
            data: { type, role },
            value,
        };
    }
    TotalFn.make = make;
    function value(context, ...argVals) {
        const values = argVals[0];
        const index = context.frame.index;
        if (!(index in values)) {
            throw new Error(`TotalFn.value(): Frame index is out of range`);
        }
        const value = values[index];
        return {
            state: context.state,
            value: value !== null && value !== void 0 ? value : null,
        };
    }
    TotalFn.value = value;
    function validate(callNode, callName, args) {
        return validateArguments({
            meta: {
                name: TotalFn.Name,
                signature: TotalFn.Signature,
                location: callNode.location,
            },
            arguments: [
                {
                    stages: ["AGGREGATE"],
                },
            ],
        }, args);
    }
    TotalFn.validate = validate;
})(TotalFn || (TotalFn = {}));
